angular.module('bmsApp.accounting').controller('CreditInvoiceFormCtrl', function ($scope,
																				  $q,
																				  ConfigService,
																				  PaymentTypeSvc,
																				  AccountingSvc) {

	$scope.config = ConfigService.config;
	$scope.datePickerBasicConfig = angular.copy($scope.config.datePicker.basic);
	$scope.datePickerBasicConfig.options.parentEl = '.modal-content';

	angular.extend($scope.ciForm, {
		loading: true,
		processing: false,
		creditInvoice: {
			credited_invoice: null,
			credit_amount: 0,
			invoice_date: moment().format('YYYY-MM-DD'),
			notes: ''
		},
		methods: {
			init: function () {
				var initPromises = {
					existingInvoice: AccountingSvc.read($scope.ciModal.invoice.id),
					paymentTypeOptions: PaymentTypeSvc.options()
				};
				$q.all(initPromises).then(function (responses) {
					$scope.ciForm.creditInvoice.credited_invoice = responses.existingInvoice.data.invoice;
					$scope.ciForm.isCancelled = false;
					$scope.ciForm.isInactive = false;
					$scope.ciForm.isClosed = false;
					if ($scope.isMM()) {
						$scope.ciForm.isClosed = $scope.ciForm.creditInvoice.credited_invoice.job_part.closed;
					}
					else if ($scope.isSM()) {
						$scope.ciForm.isCancelled = $scope.ciForm.creditInvoice.credited_invoice.job.cancelled;
						$scope.ciForm.isInactive = $scope.ciForm.creditInvoice.credited_invoice.job.cancelled;
						$scope.ciForm.isClosed = $scope.ciForm.creditInvoice.credited_invoice.job.closed;
					}
					else if ($scope.isTG()) {
						// Only disallow crediting if invoice method is after each visit and the visit is not closed or inactive
						if ($scope.ciForm.creditInvoice.credited_invoice.job.invoice_method === 'each_visit') {
							let tgVisit = $scope.ciForm.creditInvoice.credited_invoice.visit;
							if (angular.isObject(tgVisit)) {
								$scope.ciForm.isClosed = tgVisit.closed || tgVisit.inactive;
							} else {
								// treat job as closed for creditable logic
								$scope.ciForm.isClosed = true;
							}
						}
						else {
							// treat job as closed for creditable logic
							$scope.ciForm.isClosed = true;
						}
					}
					$scope.ciForm.isCreditable = false;
					let isManual = $scope.ciForm.creditInvoice.credited_invoice.is_manual === true || $scope.ciForm.creditInvoice.credited_invoice.is_manual === 1;
					if ($scope.ciForm.isCancelled === true || $scope.ciForm.isInactive === true || $scope.ciForm.isClosed === true || isManual) {
						$scope.ciForm.isCreditable = true;
					}
					// Let's just always allow Merrymaids invoices to be credited, for now...
					if ($scope.isMM()) {
						$scope.ciForm.isCreditable = true;
					}
					$scope.ciForm.paymentTypeOptions = responses.paymentTypeOptions.data.options;
					$scope.ciForm.loading = false;
				});
			},
			isCheque: function () {
				if (angular.isObject($scope.ciForm.creditInvoice.payment_type)) {
					return $scope.ciForm.creditInvoice.payment_type.value.toLowerCase().indexOf('cheque') > -1;
				}
				else {
					return false;
				}
			}
		},
		eventHandlers: {
			onCreditAmountChange: function () {
				// don't let user input over total_gross + credited_gross(negative amount)
				var uncredited = $scope.ciForm.creditInvoice.credited_invoice.total_gross + $scope.ciForm.creditInvoice.credited_invoice.credited_gross;
				var crediting = $scope.ciForm.creditInvoice.credit_amount;
				if (crediting > uncredited) {
					$scope.ciForm.creditInvoice.credit_amount = uncredited;
				}
			}
		},
		formvalidatorconfig: {
			submitHandler: function () {
				if ($scope.ciForm.creditInvoice.credit_amount < 0.01) {
					$scope.ciForm.errors = [
						'Amounting crediting must be greater than £0.00'
					];
					return;
				}

				$scope.ciForm.processing = true;
				var modalResult = {};
				AccountingSvc.saveInvoiceCredit($scope.ciForm.creditInvoice).then(function (response) {
					modalResult.success = response.data.success;
				}, function (error) {
					modalResult.error = error;
				})
					.finally(function () {
						if (angular.isObject($scope.ciModal)) {
							$scope.ciModal.instance.close(modalResult);
						}
					});
			},
			errorPlacement: function (error) {
				error.appendTo('#credit-invoice-errors');
			},
			errorContainer: '#credit-invoice-errors'
		}
	});

	$scope.ciForm.methods.init();

});
